const nbNO = {
  glossary: {
    change: 'Endre',
    showPrevious: 'Vis forrige',
    showNext: 'Vis neste',
    showPreviousImage: 'Vis forrige bilde',
    showNextImage: 'Vis neste bilde',
    readMore: 'Les mer',
    closeModal: 'Lukk modalen',
    homeUrl: 'https://www.drive.no',
    goToHome: 'Gå til drive.no',
    company: 'Drive',
    modalTitle: 'Drive Ecom',
    add: 'Legg til',
    chosen: 'Valgt',
    ourAdvantages: 'Fordeler med å kjøpe bilen online hos oss',
    showHelp: 'Vis hjelp',
    closeHelp: 'Lukk hjelp',
    whatDoesThisMean: 'Hva betyr dette?',
    buyOnline: 'Kjøp online hos oss',
  },
  confirmClose: {
    heading: 'Bilen er ikke reservert ennå',
    message:
      'Du har ikke klikket deg gjennom alle trinnene som kreves for at bestillingen skal fullføres og bilen skal reserveres til deg. Er du sikker på at du vil avslutte bestillingen din?',
    abortButton: 'Fortsett min bestilling',
    confirmButton: 'Avbryt min bestilling',
  },
  accessoryItemInfo: {
    backButton: 'Tilbake',
    logoAlt: 'Produsentens logo for',
  },
  accessories: {
    title: 'Tilbehør',
    noSelected: 'Ingen valgt',
    changeButtonTitle: 'Endre tilbehør',
    heading: 'Vil du kjøpe tilbehør til din nye bil?',
    description: 'Her viser vi noen av tilbehørene som passer til din nye bil.',
    proceedButton: 'Gå videre',
    skipButton: 'Hopp over dette trinnet',
  },
  centralStorage: {
    title: 'Sentral lager',
    heading: 'Hvilket anlegg vil du kjøpe fra?',
    description:
      'Dette kjøretøyet er en sentrallagerbil og er tilgjengelig fra flere anlegg. Velg anlegget du vil handle fra.',
    changeButtonTitle: 'Endre',
    proceedButton: 'Gå videre',
    errorMessage: 'En feil oppstod, og det var ikke mulig å velge ovennevnte anlegg. Prøv igjen.',
    dealerSelection: 'Valg av anlegg',
    addressMissing: 'Adresse mangler',
  },
  confirmation: {
    title: 'Fullfør bestillingen',
    paymentTitle: 'Betaling',
    heading: 'Nesten ferdig!',
    description:
      'For å reservere bilen til deg trenger vi bare å verifisere din identitet med BankID. Etter det vil {{name}} kontakte deg for å fullføre kjøpet.',
    description2:
      'Kjøpet blir først bindende etter signering av endelig tilbud fra {{name}}. Det er også da betalingen vil foregå.',
    ageError:
      'Du må være over 18 år for å kunne fortsette. Identifisering med BankID viser at du er under 18 år gammel.',
    requestError: 'En feil oppstod, og det var ikke mulig å opprette bestillingen, prøv igjen.',
    notAvailable: 'Denne bilen er dessverre ikke lenger tilgjengelig.',
    socialIdNotMatchingError:
      'Personnummeret i første trinn samsvarer ikke med det som er knyttet til BankID',
    confirmConditionsTitle: 'Jeg godkjenner {{link}}.',
    insuranceText: 'og har tatt del av informasjonen om forsikringsformidling',
    reserveButton: 'Reserver bilen',
    policyText: 'Dine personopplysninger behandles og lagres i samsvar med vår {{link}}.',
    reservationDisclaimer:
      'Vi forbeholder oss retten til eventuelle endringer i tilgjengeligheten av tilbudte biler.',
    bankIdDescriptionQrCode:
      'For å verifisere din identitet, start BankID-applikasjonen på din andre enhet.',
    bankIdDescriptionSameDevice: 'For å verifisere din identitet, start BankID-applikasjonen.',
    bankIdErrorMessage: 'Det var ikke mulig å hente status for nåværende BankID-signering.',
    bankIdQrCodeErrorMessage: 'Det var ikke mulig å hente ny QR-kode for BankID-signering.',
    bankIdInitErrorMessage: 'Det var dessverre ikke mulig å initiere BankID. Vennligst prøv igjen.',
    bankIdCompletedMessage: 'Verifisering fullført, bestillingen opprettes nå...',
    paymentHeading: 'Velg betalingsmåte',
    paymentDescription:
      'Gjennomfør en forskuddsbetaling på 5% av bilens pris (10 995 kr) for å reservere bilen. Velg hvordan du vil gjennomføre betalingen.',
    paymentDescription2:
      'Resterende del av kontantinnsatsen 32 985 kr med eventuelt fradrag for innbyttebil betales hos {{name}} ved kontraktsignering.',
    paymentCardType: 'Korttype',
    paymentCardTypeValue: 'Kreditt',
    paymentCardNo3DSecure: 'Kort uten 3D secure',
    paymentCardNo3DSecureValue: '4925000000000004',
    paymentCard3DSecure: 'Kort med 3D secure',
    paymentCard3DSecureValue: '4761739001010416',
    paymentExpiry: 'MM/ÅÅ:',
    paymentExpiryValue: '12/25',
    paymentCVC: 'CVC:',
    paymentCVCValue: '123',
    privacyPolicy: 'personvernpolicy',
    purchaseTermsAndCancellationPolicy: 'kjøpsvilkår og vilkår for angrerett',
    noVerifyConfirmMessage: 'Elit in eiusmod cupidatat tempor elit fugiat ad.',
  },
  customer: {
    title: 'Dine opplysninger',
    changeButtonTitle: 'Endre dine opplysninger',
    email: 'E-post',
    phone: 'Telefonnummer',
    socialId: 'Personnummer',
    name: 'Navn',
    givenName: 'Fornavn',
    surname: 'Etternavn',
    address: 'Adresse',
    street: 'Gateadresse',
    street2: 'Leilighet, etasje, etc.',
    registeredAddress: 'Registrert adresse',
    postalCode: 'Postnummer',
    city: 'Poststed',
    contactInfoTitle: 'Kontaktinformasjon',
    contactInfoDescription: 'Oppgi din e-postadresse og telefonnummer.',
    emailPlaceholder: 'Oppgi din e-postadresse',
    emailErrorMessage: 'En gyldig e-postadresse må oppgis',
    phonePlaceholder: 'Oppgi ditt telefonnummer',
    phoneErrorMessage: 'Oppgi ditt telefonnummer',
    givenNamePlaceholder: 'Oppgi fornavnet ditt',
    givenNameErrorMessage: 'Oppgi fornavnet ditt',
    surnamePlaceholder: 'Oppgi etternavnet ditt',
    surnameErrorMessage: 'Oppgi etternavnet ditt',
    streetPlaceholder: 'Oppgi din gateadresse',
    streetErrorMessage: 'Oppgi din gateadresse',
    street2Placeholder: 'Leilighet, etasje, etc.',
    street2ErrorMessage: 'Leilighet, etasje, etc.',
    postalCodePlaceholder: 'Oppgi postnummeret ditt',
    postalCodeErrorMessage: 'Oppgi postnummeret ditt',
    cityPlaceholder: 'Oppgi poststed',
    cityErrorMessage: 'Oppgi poststed',

    proceedButton: 'Gå videre',
    personalInfoTitle: 'Personopplysninger',
    personalInfoDescription: 'Oppgi ditt personnummer for å hente ditt navn og adresse.',
    socialIdPlaceholder: 'ÅÅÅÅMMDD-XXXX',
    socialIdErrorMessage: 'Oppgi personnummer i formatet ÅÅÅÅMMDD-XXXX. Må være over 18 år.',
    fetchButton: 'Hent opplysninger',
    fetchErrorMessage: 'Vi fikk dessverre ingen treff på personnummeret du oppga.',
    fetchInfoMessage: 'Vi vil hente følgende opplysninger om deg:',
    policyText: 'Dine personopplysninger behandles og lagres i samsvar med vår {{link}}.',
    changeContactsButton: 'Endre',
  },
  delivery: {
    title: 'Levering',
    deliveryMethod: 'Leveringsmåte',
    homeDelivery: 'Hjemlevering',
    pickup: 'Hent hos forhandleren',
    changeDeliveryMethod: 'Endre leveringsmåte',
    heading: 'Hvordan vil du ha bilen levert?',
    description:
      'Velg om du vil ha bilen levert hjem til deg eller om du vil hente den hos {{name}}.',
    free: 'Gratis',
    toYourAddress: 'Til din registrerte adresse',
    tooFarAway: 'Dessverre kan vi ikke tilby hjemlevering til din adresse.',
    proceedButton: 'Gå videre',
  },
  creditAssessment: {
    loanApplication: 'Lånesøknad',
    loanApplicationDescription:
      'For å besvare din forespørsel om billån trenger {{name}} noen flere opplysninger om deg og din husstand. Spørsmålene tar bare noen minutter å besvare. Bekreft og signer deretter med BankID – deretter får du ditt lånebeskjed direkte på skjermen og kan gå videre med ditt bilkjøp. Blir du godkjent så gjelder lånebeskjeden gjennom hele kjøpet så lenge ingen tillegg gjøres – men din søknad er ikke bindende.',
    maritalStatus: 'Sivilstatus',
    employment: 'Sysselsetting',
    children: 'Barn',
    income: 'Inntekt',
    housingType: 'Boligtype',
    housingTypeDescription: 'Oppgi type bolig.',
    housingCost: 'Boligkostnad',
    debtsAndLiabilities: 'Gjeld og forpliktelser',
    debtsAndLiabilitiesDescription:
      'Oppgi eventuelle gjeld og forpliktelser innenfor respektive kategori.',
    totalLoanAmount: 'Totalt lånebeløp',
    noPaymentInfo:
      'Du betaler ingenting i dette trinnet, dette er bare en lånesøknad. Kjøpet fullføres deretter ved møte med {{name}}.',
    caseError: 'Det var ikke mulig å starte en lånesøknad, prøv igjen. {{caseError}}',
    bankIdError: 'En feil oppstod med BankID, prøv igjen.',
    performLoanApplication: 'Gjennomfør lånesøknad',
    disclaimer:
      'Ved å klikke på "Gjennomfør lånesøknad" godkjenner jeg at {{name}} gjør en kredittsjekk på meg basert på informasjonen ovenfor, og jeg bekrefter at jeg har lest {{link}}.',
    disclaimerSafe: 'Dine opplysninger lagres og oppbevares sikkert.',
    whyAnswer: 'Hvorfor må jeg svare på alt dette?',
    whyAnswerDescription:
      '{{name}} må innhente opplysningene fra kunden for å oppfylle bestemmelser i Forbrukerkredittloven (2010:1846) og Lov (2017:630) om tiltak mot hvitvasking og finansiering av terrorisme.',
    waitingFor: 'Venter på {{name}}...',
    fetchingInfo: 'Henter opplysninger fra {{name}}. Vent, det kan ta noen sekunder.',
    errorOccurred: 'En feil oppstod',
    bankIdStatusError: 'Det var ikke mulig å hente status for nåværende BankID-signering',
    descriptionQrCode:
      'For å hente dine opplysninger, start BankID-applikasjonen på din andre enhet.',
    descriptionSameDevice: 'For å hente dine opplysninger, start BankID-applikasjonen.',
    incomePerMonth: 'Inntekt per måned før skatt',
    incomeError: 'Oppgi din inntekt per år før skatt',
    incomeDescription: 'Lønn og/eller pensjon, ikke bidrag eller studielån.',
    childrenUnder18: 'Antall barn under 18 år',
    childrenError: 'Velg antall barn',
    selectChildren: 'Velg antall barn',
    tenOrMore: '10 eller flere',
    myPartOfMonthlyFee: 'Min del av månedsavgiften',
    myPartOfMonthlyRent: 'Min del av månedshusleien',
    excludingInterest: 'Eksklusive renter og avdrag',
    housingCostError: 'Oppgi boligkostnader per måned',
    cardCredits: 'Kredittkort',
    cardCreditsError: 'Oppgi kredittkort eller la stå tomt',
    totalDebt: 'Total gjeld',
    vehicleLoan: 'Billån',
    vehicleLoanError: 'Oppgi billån eller la stå tomt',
    collateral: 'Sikkerhet',
    collateralError: 'Oppgi sikkerhet eller la stå tomt',
    totalAmount: 'Totalt beløp.',
    leasingFees: 'Bil leasing',
    leasingFeesError: 'Oppgi bil leasingkostnader eller la stå tomt',
    privateLoan: 'Privatlån (ikke boliglån og studielån)',
    privateLoanError: 'Oppgi privatlån eller la stå tomt',
    fullTimeEmployed: 'Fast ansatt',
    temporarilyEmployed: 'Midlertidig ansatt',
    selfEmployed: 'Selvstendig næringsdrivende',
    retired: 'Pensjonist',
    student: 'Student',
    other: 'Annet',
    married: 'Gift/partnerskap',
    commonLaw: 'Samboer',
    single: 'Enslig',
    singleFamily: 'Enebolig',
    condominium: 'Borettslag',
    apartment: 'Leilighet',
    proceedButton: 'Gå videre',
    abortButton: 'Avbryt',
    assessManually: 'Kredittsjekken må gjøres manuelt. Vennligst kontakt {{name}} for å fortsette.',
    dataProtectionPolicy: 'personvernpolicy',
    readMore: 'Les mer om dette her',
  },
  financial: {
    title: 'Finansiell informasjon',
    description: 'Oppgi din finansielle informasjon for å fortsette.',
    income: 'Inntekt',
    incomePlaceholder: 'Oppgi din inntekt',
    incomeErrorMessage: 'En gyldig inntekt må oppgis',
    expenses: 'Utgifter',
    expensesPlaceholder: 'Oppgi dine utgifter',
    expensesErrorMessage: 'Gyldige utgifter må oppgis',
    assets: 'Eiendeler',
    assetsPlaceholder: 'Oppgi dine eiendeler',
    assetsErrorMessage: 'Gyldige eiendeler må oppgis',
    liabilities: 'Gjeld',
    liabilitiesPlaceholder: 'Oppgi din gjeld',
    liabilitiesErrorMessage: 'Gyldig gjeld må oppgis',
    proceedButton: 'Gå videre',
    abortButton: 'Avbryt',
    heading: 'Finansiering',
    howToFinance: 'Hvordan vil du finansiere din {{vehicleTitle}} {{vehicleDescription}}?',
    buyCar: 'Kjøp bilen',
    buyCarDescription:
      'Du kjøper bilen og eier den selv, enten ved å betale hele bilen med egne midler eller gjennom et billån. Du er selv ansvarlig for salget av bilen og velger selvfølgelig helt fritt når det skal finne sted.',
    leaseCar: 'Leie bilen',
    leaseCarDescription:
      'Når du privatleier en bil eier du den ikke selv, men betaler en månedsavgift i en avtalt periode som dekker en viss kjørelengde og andre avtalte tjenester.',
    cash: 'Kontant',
    cashDescription:
      'Betaling skjer hos {{contactName}} ved kontraktsignering. Ingen kostnader tilkommer.',
    loanApplicationOnline: 'Lånesøknad online med BankID',
    loanApplicationResponse: ' – svar direkte!',
    paymentAtContract: 'Betaling skjer hos {{contactName}} ved kontraktsignering.',
    calculatedOn: 'Beregnet på {{creditAmount}} kr, {{duration}} mnd, {{interest}}% rente.',
    from: 'Fra',
    proceed: 'Gå videre',
    privateLeasing: 'Privatleasing',
    privateLeasingDescription:
      'Når du privatleier en bil eier du den ikke selv, men betaler en månedsavgift i en avtalt periode som dekker en viss kjørelengde og andre avtalte tjenester.',
    financialInformationToggle: 'Finansiell informasjon',
    financialCashSelected: 'Kontant betaling valgt',
    financialLeaseSelected: 'Privatleasing valgt',
    financialLoanSelected: 'Billån valgt',
    financialCashSet: 'Kontant betaling satt',
    financialLeaseSet: 'Privatleasing satt',
    financialLoanSet: 'Billån satt',
    financialEdit: 'Rediger finansiering',
  },
  loan: {
    title: 'Billån',
    description: 'Finansier bilen med billån via {{name}}.',
    creditScoringInfo:
      'Gjør din lånesøknad her - og få beskjed direkte. Husk, kjøpet er ikke bindende før du har signert det endelige forslaget som utarbeides av {{name}}.',
    instruction: 'Oppgi din tenkte kontantinnsats og hvor mange måneder du vil legge opp lånet på.',
    downPaymentTitle: 'Kontantinnsats',
    downPaymentInfoTitle: 'Hvor mye av dine egne penger vil du legge?',
    downPaymentInfoDescription:
      'Kontantinnsatsen er en del av bilens pris som du betaler med egne penger. Den må være minst 20% av prisen på bilen. Kontantinnsatsen betaler du senere i forbindelse med kontraktsignering hos {{name}}. Hvis du har en innbyttebil kan du betale kontantinnsatsen med den. Dette avtaler du sammen med {{name}} ved kontraktsignering.',
    durationTitle: 'Avbetaling',
    residualTitle: 'Restverdi',
    errorOccurred: 'En feil oppstod, prøv igjen.',
    proceedButton: 'Gå videre',
  },
  loanDetails: {
    disclaimerText:
      '*Beregnet på {{interest}} % rente (effektiv {{effectiveInterest}} %). Den renten du får settes ved kontraktsignering.',
    showDetails: 'Vis detaljer',
    details: 'Detaljer',
    repaymentPeriod: 'Avbetalingsperiode',
    months: 'mnd',
    interest: 'Rente',
    effectiveInterest: 'Effektiv rente',
    setupFee: 'Etableringskostnad',
    administrationFee: 'Administrasjonskostnader',
    totalCreditCost: 'Total kredittkostnad',
    disclaimerText1:
      '*Dette er ikke det endelige tilbudet. Renten kan endres hvis det gjøres justeringer i den opprinnelige nedbetalingsplanen, tillegg i utstyr eller andre endringer som påvirker det opprinnelige prisforslaget.',
    disclaimerText2:
      'Hvis markedsrenten endres, kan månedskostnaden endres tilsvarende. Månedskostnaden kan også påvirkes av den kredittvurderingen som gjøres etter en kredittsjekk.',
    moreInfo: 'Mer informasjon om {{loanOrgName}}',
  },
  loanDetailsDetailed: {
    showDetails: 'Vis detaljer',
    details: 'Detaljer',
    repaymentPeriod: 'Avbetalingsperiode',
    months: 'mnd',
    interest: 'Rente',
    effectiveInterest: 'Effektiv rente',
    setupFee: 'Etableringskostnad',
    administrationFee: 'Administrasjonskostnader',
    totalCreditCost: 'Total kredittkostnad',
    disclaimerText1:
      '*Dette er ikke det endelige tilbudet. Renten kan endres hvis det gjøres justeringer i den opprinnelige nedbetalingsplanen, tillegg i utstyr eller andre endringer som påvirker det opprinnelige prisforslaget.',
    disclaimerText2:
      'Hvis markedsrenten endres, kan månedskostnaden endres tilsvarende. Månedskostnaden kan også påvirkes av den kredittvurderingen som gjøres etter en kredittsjekk.',
    moreInfo: 'Mer informasjon om {{loanOrgName}}',
  },
  loanDetailsMonthlyCost: {
    monthlyCost: 'Månedskostnad for lånet',
    perMonth: 'kr/mnd*',
  },
  stageCompletedFinancial: {
    downPayment: 'Kontantinnsats',
    loanAmount: 'Lånebeløp',
    repaymentPeriod: 'Avbetalingsperiode',
    months: 'mnd',
    monthlyCost: 'Månedskostnad for lånet',
    disclaimerText:
      '*Beregnet på {{interest}} % rente (effektiv {{effectiveInterest}} %). Den renten du får settes ved kontraktsignering.',
    orderAlmostReady: 'Bestillingen er snart klar, her ser du ditt lånebeskjed:',
    changeFinancing: 'Endre finansiering',
    financing: 'Finansiering',
    cash: 'Kontant',
    lease: 'Privatleasing',
  },
  stageCompletedFinancialCreditAssessment: {
    approved: 'Gratulerer! Din lånesøknad er godkjent av {{loanName}}.',
    approvedDescription:
      'Fullfør bestillingen ved å klikke deg gjennom de neste trinnene. Har du spørsmål underveis? Kontakt {{contactName}} på tlf {{contactPhone}}.',
    assessManually:
      'Når bestillingen er fullført, vil vi gå gjennom saken din og gi deg tilbakemelding med et lånebeskjed.',
    assessManuallyDescription:
      'Bilen er fortsatt ikke reservert. Gå videre til neste trinn for å fullføre bestillingen, men det er ikke sikkert at lånet ditt vil bli godkjent. Har du spørsmål underveis? Kontakt {{contactName}} på tlf {{contactPhone}}.',
    declined: 'Vi kan dessverre ikke godkjenne din søknad om billån.',
    declinedDescription:
      'Det kan være ulike grunner til at en søknad avslås. Du vil snart motta et brev med bekreftelse og mer informasjon om din søknad.',
    declinedNextSteps:
      'Ditt allerede påbegynte kjøp kan fortsatt gjennomføres og fullføres, for å gå videre kan du velge en annen betalingsmåte.',
    contactInfo: 'Har du spørsmål underveis? Kontakt {{contactName}} på tlf {{contactPhone}}.',
  },
  loanSummary: {
    title: 'Billån',
    description: 'Bestillingen er snart klar, her ser du ditt lånebeskjed:',
    successMessage: 'Gratulerer! Din lånesøknad er godkjent av {{loanName}}.',
    notReserved:
      'Bilen er ikke reservert ennå. Fullfør bestillingen ved å klikke deg gjennom de neste trinnene. Har du spørsmål underveis? Kontakt [forhandleren] på tlf [telefonnummer].',
    downPayment: 'Kontantinnsats',
    loanAmount: 'Lånebeløp',
    repaymentPeriod: 'Avbetalingsperiode',
    monthlyCost: 'Månedskostnad for lånet',
    disclaimer:
      '*Beregnet på X,XX % rente (effektiv X,XX %). Den renten du får settes ved kontraktsignering.',
  },
  summary: {
    financing: 'Finansiering',
    cash: 'Kontant',
    loan: 'Billån',
    leasing: 'Privatleasing',
    changeButton: 'Endre',
    centralStorageTitle: 'Sentral lager',
    dealerSelection: 'Valg av forhandler',
    customerTitle: 'Kundeopplysninger',
    customerName: 'For- og etternavn',
    customerSSN: 'Personnummer',
    customerAddress: 'Adresse',
    customerEmail: 'E-post',
    customerPhone: 'Telefonnummer',
    deliveryTitle: 'Levering',
    deliveryMethod: 'Leveringsmåte',
    homeDelivery: 'Hjemlevering',
    pickup: 'Hent hos forhandleren',
    thankYou: 'Takk for din bestilling!',
    whatHappensNext: 'Dette skjer nå:',
    orderConfirmation: 'En bestillingsbekreftelse vil bli sendt til din e-postadresse {{email}}.*',
    contactFromDealer:
      '{{contactName}} tar kontakt med deg for å gå gjennom avtale, betaling og levering.',
    driveSafely: 'Klart! Kjør forsiktig på veiene.',
    orderConfirmationDisclaimer:
      '*Bestillingsbekreftelsen sendes normalt innen 10 minutter, men kan i unntakstilfeller ta opptil 48 timer.',
    orderNumber: 'Bestillingsnummer {{createdOrderId}}',
    orderTitle: 'Din bestilling',
    paymentMethod: 'Betalingsmåte',
    perMonth: 'kr/mnd',
    lease: 'Privatleasing',
    from: 'Fra',
    accessories: 'Tilbehør',
    insurance: 'Forsikring',
    free: 'Gratis',
    tradeInTitle: 'Innbyttebil',
    mileage: 'Kjørelengde',
    description: 'Beskrivelse',
    condition: 'Bilens tilstand',
    estimatedValue: 'Omtrentlig verdi',
    no: 'Nei',
  },
  insurance: {
    heading: 'Vil du tegne en forsikring på din nye bil?',
    description: 'Nedenfor vises forslag på forsikringer som passer deg og din nye bil.',
    proceedButton: 'Gå videre',
    backButton: 'Tilbake',
    logoAlt: 'Produsentens logo for {{title}}',
    ifDescription:
      'Oppgi din estimerte kjørelengde for å se din forsikringskostnad. Deretter presenterer vi forslag på forsikringer som passer deg og din nye bil. I både hel- og halvforsikring inngår trafikkforsikring som er obligatorisk å ha. Hvis du har valgt å finansiere bilen med et billån, er prisen du ser rabattert.',
    showInsurances: 'Vis forsikringer',
    ifAlert:
      'Vi er tilknyttede forsikringsformidlere til {{insuranceDisclaimerTitle}}, If Skadeforsikring. Forsikringsgiver er If Skadeforsikring (publ). Hva dette innebærer kan du lese mer om på forsikringsformidlerens nettside.',
    ifDisclaimer:
      'Ved å klikke på Vis forsikringer godkjenner du at vi sender dine opplysninger videre til {{insuranceDisclaimerTitle}} slik at de kan gi deg en pris på forsikring. Hvordan de håndterer dine personopplysninger kan du lese om på deres nettside.',
    skipButton: 'Hopp over dette trinnet',
    perMonth: 'kr/mnd',
    addons: 'Tillegg',
    includes: 'Forsikringen inneholder',
    update: 'Oppdater',
    select: 'Velg',
    estimatedMileage: 'Estimert kjørelengde',
    edit: 'Endre',
    fetchError: 'Det var ikke mulig å hente forsikringer.',
    retry: 'Prøv igjen',
    title: 'Forsikring',
    none: 'Ingen',
    changeButtonTitle: 'Endre forsikring',
  },
  tradeIn: {
    title: 'Innbyttebil',
    mileage: 'Kjørelengde',
    description: 'Beskrivelse',
    condition: 'Bilens tilstand',
    estimatedValue: 'Omtrentlig verdi',
    infoText: 'Vi sender med opplysninger om din innbyttebil til bilforhandleren.',
    infoDisclaimer:
      'Vær oppmerksom på at vurderingen som utføres gir en estimert innbytteverdi. Den endelige verdien avgjøres når forhandleren kan bekrefte bilens tilstand.',
    no: 'Nei',
    changeButtonTitle: 'Endre',
    heading: 'Har du en innbyttebil?',
    tradeInDescription:
      'Har du en bil du vil bytte inn når du kjøper din nye bil? Her får du en estimert innkjøpspris av oss direkte online.',
    yesButton: 'Jeg har innbyttebil',
    skipButton: 'Hopp over dette trinnet',
    veryGoodCondition: 'Meget god tilstand',
    goodCondition: 'God tilstand',
    okCondition: 'Helt ok tilstand',
    noScratches: 'Ingen riper eller skader',
    serviced: 'Servet ved hver anledning med stempler i serviceboken',
    goodTires: 'Dekk med veldig god mønsterdybde (5-8 mm)',
    someScratches: 'Noen mindre riper og/eller skader',
    okTires: 'Dekk som ikke trenger å byttes (mønsterdybde på 3-5 mm)',
    manyScratches: 'Det er en del riper og skader',
    notServiced: 'Ikke servet ved hver anledning',
    badTires: 'Dekk som må byttes (mønsterdybde under 3 mm)',
    detailsHeading: 'Opplysninger om din innbyttebil',
    detailsDescription:
      'Oppgi registreringsnummeret og aktuell kjørelengde for din innbyttebil så får du en estimert innkjøpspris av oss.',
    registrationNumber: 'Registreringsnummer',
    registrationNumberError: 'Et gyldig registreringsnummer i formatet AB12345 må oppgis',
    registrationNumberPlaceholder: 'Oppgi registreringsnummer',
    mileageError: 'En kjørelengde mellom 0 til 80 000 km må oppgis',
    mileagePlaceholder: 'Oppgi bilens kjørelengde',
    descriptionOptional: 'Beskrivelse (valgfritt)',
    descriptionError: 'Beskrivelsen er ikke gyldig',
    descriptionPlaceholder: 'Beskriv bilen',
    fetchValue: 'Hent estimert verdi',
    proceedButton: 'Bruk og gå videre',
    fetchError:
      'Vi fikk dessverre ingen treff på registreringsnummeret du oppga. Vennligst kontroller at registreringsnummeret stemmer.',
  },
  vehicleInfo: 'Kjøretøyinformasjon',
  orderCallback: {
    thankYou: 'Takk for ditt kjøp',
    orderId: 'Ordre id',
    waykeId: 'Drive id',
  },
  howTo: {
    heading: 'Slik kjøper du bilen online',
    description:
      'Hos oss kan du trygt kjøpe din neste bil online. Reserver bilen ved å klikke deg gjennom vår kjøpsflyt med følgende trinn:',
    timelineAriaLabel: 'Fremgangsmåte',
    customerHeading: 'Dine kundeopplysninger',
    centralStorageHeading: 'Velg anlegg',
    centralStorageDescription: 'Velg hvilket anlegg du vil kjøpe bilen fra.',
    deliveryHeading: 'Velg leveringsmåte',
    tradeInHeading: 'Har du innbyttebil?',
    tradeInDescription: 'Få den vurdert direkte online.',
    financialHeading: 'Finansiering',
    insuranceHeading: 'Vil du tegne en forsikring?',
    insuranceDescription: 'Se forslag på forsikringer som passer din nye bil.',
    accessoriesHeading: 'Tilbehør',
    accessoriesDescription: 'Bestill ekstra utstyr til bilen din.',
    financialDescriptionAll:
      'Denne bilen kan du kjøpe kontant, privatleie eller finansiere med et billån.',
    financialDescriptionCashLease: 'Denne bilen kan du kjøpe kontant eller privatleie.',
    financialDescriptionCashLoan: 'Denne bilen kan du kjøpe kontant eller finansiere med et billån',
    financialDescriptionLoanLease: 'Denne bilen kan du privatleie eller finansiere med et billån',
    financialDescriptionCash: 'Denne bilen kan du kjøpe kontant.',
    financialDescriptionLoan: 'Denne bilen kan du finansiere med et billån',
    financialDescriptionLease: 'Denne bilen kan du privatleie.',
    deliveryDescriptionBoth: 'Hjemlevering eller hent hos forhandleren.',
    deliveryDescriptionPickup: 'Hent hos forhandleren.',
    deliveryDescriptionHome: 'Hjemlevering.',
    paymentHeading: 'Gjennomfør forskuddsbetaling!',
    paymentDescription:
      'Gjennomfør forskuddsbetaling på 5% av bilens verdi. (Gjennomfør betaling av depositum tilsvarende 5% av bilens verdi.)',
    finalHeading: 'Klart!',
    finalDescription:
      'Etter at bestillingen er gjennomført tar {{contactName}} kontakt med deg for å avtale detaljer rundt betaling og signere avtalen.',
  },
  preview: {
    heading: 'Så gøy at du vil kjøpe denne bilen!',
    proceedButton: 'Gå videre',
    checklistTitle: 'Kjøp online hos Drive',
    checklistAriaLabel: 'Fordeler med å kjøpe bilen online hos Drive',
    checklistItem1: 'Trygg håndtering av personopplysninger',
    checklistItem2: 'Reserver bilen nå - betaling og avtalesignering skjer senere med forhandleren',
    checklistItem3: 'Ikke bindende før avtale er signert med forhandleren',
    checklistItem4: 'Kun kontrollerte biler',
    error: 'En feil oppstod og det var ikke mulig å initiere modulen. Prøv igjen.',
  },
};

export default nbNO;
